import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getLanguage } from "../../Utils/services";

export const CheckPickupOrder = ({ children }) => {
    const [isOrderOpen, setIsOrderOpen] = useState(true);
    const route = useSelector((state) => state.user.route)
    
    useEffect(() => {
        axios.get('/api/pickup/order/is_open')
            .then((data) => {
                if (data.data.UsePickupOrder) {
                    setIsOrderOpen(true)
                    getLanguage('pickup');
                }
                else setIsOrderOpen(false)
            })
    }, [route])

    if (!isOrderOpen) {
        // user is not authenticated
        return <Navigate to="/req-pickuporder" />;
    }

    return children;
};